import { useCapuchinMutation } from '../useCapuchinMutation';
import { ADD_CUSTOM_EVENT } from './useAddCustomEvent.graphql';
import {
  IHandleAddCustomEventParams,
  IAddCustomEventMutationGraphQLResponse,
  IAddCustomEventMutationVariables,
  IUseAddCustomEventOptions,
  IUseAddCustomEvent,
} from './useAddCustomEvent.interfaces';

const useAddCustomEvent = (options?: IUseAddCustomEventOptions): IUseAddCustomEvent => {
  const { mutation, onCompleted, onError, product, tokens } = options ?? ({} as IUseAddCustomEventOptions);

  const [executeAddCustomEvent, { loading: isLoading }] = useCapuchinMutation<IAddCustomEventMutationGraphQLResponse, IAddCustomEventMutationVariables>({
    mutation: mutation ?? ADD_CUSTOM_EVENT,
    options: {
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          events: { addCustom: hasAddedCustom },
        } = data;

        onCompleted({
          addCustom: hasAddedCustom,
        });
      },
      onError,
    },
    product,
    tokens,
  });

  const handleAddCustomEvent = async ({ projectId, type, metadata }: IHandleAddCustomEventParams) => {
    await executeAddCustomEvent({
      variables: {
        projectId, type, metadata
      },
    });
  };

  return {
    handleAddCustomEvent,
    isLoading,
  };
};

export { useAddCustomEvent };
